import { percentToAbs } from '../../utils/fmtUtils'
import { colorPartido } from '../../utils'
import {responsive} from '../../resources/constantes.json'

export const option = (partido, nomenclator, horizontal, isMobile, windowWidth, hasData) => {
	const absValue = percentToAbs(partido.pvot);
	const color = colorPartido(nomenclator, partido.codpar)
	return horizontal ? getHorizontalBar(absValue, color, isMobile, windowWidth, hasData) : getVerticalBar(absValue, color, hasData);
}

const getHorizontalBar = (absValue, color, isMobile, windowWidth, hasData) => {
	const med = Number(windowWidth.width) < ((Number(responsive.mobile) - Number(responsive.smallMobile)) / 2 + Number(responsive.smallMobile));
	return {
		grid: {
			left: '0',
			right: '0',
		},
		xAxis: {
			show: false,
			type: 'value',
			max: 120,
			width: '100%'
		},
		yAxis: {
			show: false,
			type: 'category',
		},
		series: [
			{
				data: [{
					value: absValue,
					itemStyle:{
						color: color
					},
					label: {
						show: true,
						position: 'right',
						valueAnimation: true,
						color:"#000",
						fontWeight: 600,
						fontSize: isMobile ? '18' : '22',
						fontFamily: 'Lato',
						verticalAlign: 'middle',
						formatter: function(data) {
							return data.value.replace(".",",") + "%";
						}	
					}
				}],
				type: 'bar',
				showBackground: true,
				backgroundStyle: {
					color: hasData ? 'transparent' : 'rgba(224,224,224,0.5)'
				},
				barHeight: '100%'
			}
		]
	}
}

const getVerticalBar = (absValue, color, hasData) => {
	return {
		grid: {
			top: '0',
			bottom: '0%',
		},
		xAxis: {
			show: false,
			type: 'category',
			width: '150px'
		},
		yAxis: {
			show: false,
			type: 'value',
			max: 110,
		},
		itemStyle:{
			color: color
		},
		series: [
			{
				data: [{
					value: absValue,
					label: {
						show: true,
						position: 'top',
						valueAnimation: true,
						color:"#000",
						fontWeight: 600,
						fontSize: '28',
						fontFamily: 'Lato',
						formatter: function(data) {
							return data.value.replace(".",",") + "%";
						}				
					},
				}],
				type: 'bar',
				showBackground: true,
				backgroundStyle: {
					color: hasData ? 'transparent' : 'rgba(224,224,224,0.3)'
				},
				barWidth: '100%'
			}
		]
	}
}